import { Button, PageHeader } from 'components';
import {
  Row,
  Col,
  Table,
  Select,
  Typography,
  Checkbox,
  DatePicker,
  Upload,
} from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, InboxOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useInvoices from '../useInvoices';
import Helpers from '../../../../../helpers';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import uuid from 'react-uuid';
import FormHelper from '../../../../../helpers/FormHelper';
import NotificationFormForEdit from '../../../../../components/modules/notificationFormForEdit';
import ShowError from '../../../../../components/showError';
import { renderGroupedShopOptions } from 'components/shopOptions';

function getDaysArrayByMonth(date) {
  var daysInMonth = date.daysInMonth();
  var arrDays = [];

  while (daysInMonth) {
    var current = date.date(daysInMonth).format('YYYY-MM-DD');
    arrDays.push(current);
    daysInMonth--;
  }
  return arrDays.reverse();
}

const Edit = ({ isNew, isFile }) => {
  const {
    shops,
    inactiveShops,
    handleCreateOrUpdate,
    updateInProcess,
    editColumns,
    columnsForEdit,
    setEditColumns,
    pageFilters,
    approveErrors,
    singleItem,
    handleApprove,
  } = useInvoices();
  const { t } = useTranslation();
  const [companyId, setCompanyId] = useState('');
  const [file, setFile] = useState(null);
  const [date, setDate] = useState(null);
  const [checked, setChecked] = useState(false);
  const title = isNew ? t('CREATO') : t('MODIFICA');
  const [errors, setErrors] = useState({});

  const handleSave = async () => {
    if (!companyId) {
      setErrors({
        company: 'Company è obbligatorio',
      });
      return;
    }
    await handleCreateOrUpdate(
      {
        confirmed: checked ? 1 : 0,
        company_id: companyId,
      },
      file,
      date,
    );
  };

  useEffect(() => {
    if (date) {
      const dates = getDaysArrayByMonth(date).map((i) => ({
        invoice_date: i,
        uuid: uuid(),
        taxable: 0,
        taxable_vat: 0,
        receipts: 0,
        pieces: 0,
      }));
      setEditColumns(dates);
    }
  }, [date]);

  const disableDates =
    pageFilters.find((i) => i.company.id === companyId)?.data?.days || [];

  return (
    <div>
      <PageHeader title={title}>
        {isNew && (
          <Row gutter={16}>
            <Col>
              <Button
                width={'150px'}
                big
                onClick={handleSave}
                icon={<CheckOutlined />}
                loading={updateInProcess}
                disabled={!checked}
              >
                {t('Invia')}
              </Button>
            </Col>
          </Row>
        )}
      </PageHeader>
      <div className={styles.content}>
        {isNew && (
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Typography>{t('Insegna')}</Typography>
              <br />
              <Select
                value={companyId}
                onChange={setCompanyId}
                disabled={!isNew}
                placeholder={t('Insegna')}
                className={styles.select}
                {...Helpers.addSearchProps()}
              >
                {renderGroupedShopOptions({
                  shops,
                  inactiveShops,
                  t,
                })}
              </Select>
              <ShowError errors={errors.company ? [errors.company] : []} />
            </Col>
            <Col span={24}>
              <Typography>{t('Periodo')}</Typography>
              <br />
              <DatePicker
                value={date}
                onChange={setDate}
                picker={'month'}
                disabledDate={(currentDate) => {
                  if (disableDates) {
                    const isDisabled = disableDates.some((i) => {
                      const date = moment(i, 'YYYY-MM-DD');
                      return (
                        currentDate?.isSameOrAfter(date.startOf('month')) &&
                        currentDate?.isSameOrBefore(date.endOf('month'))
                      );
                    });
                    if (isDisabled) {
                      return isDisabled;
                    }
                  }
                  return currentDate.isAfter(moment().startOf('month'));
                }}
              />
            </Col>
            {!isFile && (
              <>
                <Col span={24}>
                  <Table
                    columns={columnsForEdit}
                    dataSource={editColumns}
                    pagination={false}
                    size='small'
                    rowKey='id'
                    loading={updateInProcess}
                    scroll={{ x: 1000 }}
                  />
                </Col>
              </>
            )}
            {isFile && (
              <>
                <Col span={24}>
                  <Upload.Dragger
                    multiple={false}
                    name='file'
                    fileList={file ? [file] : []}
                    beforeUpload={FormHelper.beforeUpload}
                    onChange={(file) => setFile(file.file)}
                  >
                    <p className='ant-upload-drag-icon'>
                      <InboxOutlined />
                    </p>
                    <p className='ant-upload-text'>
                      {t('Click or drag file to this area to upload')}
                    </p>
                  </Upload.Dragger>
                </Col>
                <Col span={24}>
                  <Typography>{t('Esempio')}</Typography>
                  <br />
                  <Table
                    pagination={false}
                    columns={[
                      {
                        title: t('Data'),
                        dataIndex: 'invoice_date',
                      },
                      {
                        title: t('Imponibile'),
                        dataIndex: 'taxable',
                      },
                      {
                        title: t('Imponibile + iva'),
                        dataIndex: 'taxable_vat',
                      },
                      {
                        title: t('N.scontrini'),
                        dataIndex: 'receipts',
                      },
                      {
                        title: t('N.pezzi'),
                        dataIndex: 'pieces',
                      },
                    ]}
                    dataSource={[
                      {
                        invoice_date: '01.02.2022 00:00:00',
                        taxable: 100,
                        taxable_vat: 100,
                        receipts: 100,
                        pieces: 100,
                      },
                      {
                        invoice_date: '02.02.2022 00:00:00',
                        taxable: 100,
                        taxable_vat: 100,
                        receipts: 100,
                        pieces: 100,
                      },
                      {
                        invoice_date: '03.02.2022 00:00:00',
                        taxable: 100,
                        taxable_vat: 100,
                        receipts: 100,
                        pieces: 100,
                      },
                    ]}
                  />
                </Col>
              </>
            )}

            <Col span={24}>
              <br />
              <Checkbox
                onClick={() => {
                  setChecked((s) => !s);
                }}
              >
                Confermo l'inserimento dei dati coretti
              </Checkbox>
            </Col>
          </Row>
        )}

        {!isNew && (
          <NotificationFormForEdit
            approveErrors={approveErrors}
            status={singleItem.status}
            loading={updateInProcess}
            handleOnFinish={handleApprove}
            showApprove={true}
            showReject={true}
            showToAdim={false}
            showRefuse={false}
          />
        )}
        <br />
      </div>
    </div>
  );
};

export default Edit;
